import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ZoomIn } from "lucide-react";
import { PORTFOLIO } from "@/lib/site";
import { Reveal, Stagger, StaggerItem } from "@/lib/motion";

export const Portfolio = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="portfolio" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <Reveal className="max-w-2xl mb-14">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Portfólio</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#012a60] text-balance">
            Alguns dos nossos trabalhos
          </h2>
        </Reveal>

        <Stagger className="grid gap-4 grid-cols-2 lg:grid-cols-4 auto-rows-[180px] sm:auto-rows-[240px]">
          {PORTFOLIO.map((p, i) => (
            <StaggerItem
              key={i}
              className={i % 5 === 0 ? "col-span-2 row-span-2" : ""}
            >
              <motion.button
                layoutId={`port-${i}`}
                onClick={() => setActive(i)}
                data-testid={`portfolio-item-${i}`}
                className="group relative h-full w-full overflow-hidden rounded-2xl ring-1 ring-black/5"
              >
                <img
                  src={p.src}
                  alt={p.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#012a60]/80 via-[#012a60]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="absolute inset-x-0 bottom-0 p-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                  <p className="text-[11px] font-bold uppercase tracking-widest text-[#55c0e0]">{p.cat}</p>
                  <p className="text-sm font-semibold text-white">{p.title}</p>
                </div>
                <span className="absolute top-3 right-3 grid place-items-center h-9 w-9 rounded-full bg-white/90 text-[#012a60] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <ZoomIn size={16} />
                </span>
              </motion.button>
            </StaggerItem>
          ))}
        </Stagger>
      </div>

      <AnimatePresence>
        {active !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActive(null)}
            data-testid="portfolio-lightbox"
            className="fixed inset-0 z-[60] grid place-items-center bg-[#012a60]/90 backdrop-blur-md p-4"
          >
            <button
              className="absolute top-6 right-6 grid place-items-center h-11 w-11 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
              data-testid="lightbox-close"
            >
              <X />
            </button>
            <motion.div
              layoutId={`port-${active}`}
              className="relative max-w-4xl w-full max-h-[85vh] overflow-hidden rounded-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <img src={PORTFOLIO[active].src} alt={PORTFOLIO[active].title} className="w-full h-full object-contain bg-black max-h-[85vh]" />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <p className="text-xs font-bold uppercase tracking-widest text-[#55c0e0]">{PORTFOLIO[active].cat}</p>
                <p className="text-lg font-semibold text-white">{PORTFOLIO[active].title}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
